module.exports = __webpack_public_path__ + "img/L_7H.a8fb1fee.png";